import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rodape: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 64,
    backgroundColor: '#dfdfe6',
    fontFamily: 'IBM Plex Sans',
    color: '#5e6784',
    fontSize: 16,
  },
}));

const Footer = (props) => {
  const { noMargin } = props;
  const classes = useStyles();
  return (
    <>
      <div className={classes.rodape} style={{ marginTop: !noMargin ? 30 : 0 }}>
        Portal do Conselho Deliberativo Nacional - Sebrae - 2024
      </div>
    </>
  );
}

export default Footer;
